import React from 'react';
import { connect } from 'react-redux';

const mapStateToProps = state => ({
  width: state.qrDesigner.size.width,
  height: state.qrDesigner.size.height,
});

const Message = ({ children, width, height }) => {
  return (
    <div style={{ position: 'absolute' }}>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height, width }}>
        <div style={{
          display: 'flex', flexDirection: 'column', border: '1px solid white', background: '#666666', margin: '20px', padding: '20px', textAlign: 'center', color: 'white',
        }}>
          {children}
        </div>
      </div>
    </div>
  );
}

export default connect(mapStateToProps)(Message);
